import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseInfoService } from '@api/base-info.service';
import { PortsService } from '@api/ports.service';
import { AddressModel } from '@shared/model/address.model';
import { ContainerLoadTypeResponseDataModel } from '@shared/model/container-load-type-response.model';
import { CustomsModel } from '@shared/model/customs.model';
import { PortTypeModel } from '@shared/model/port-type.model';
import { TransPortTypeResponseData } from '@shared/model/transportType-response.model';
import { CustomsService } from '@shared/services/customs.service';
import { QuotePersistService } from 'app/features/quote-request/quote-persist.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-customs',
  templateUrl: './customs.component.html',
  styleUrls: ['./customs.component.scss']
})
export class CustomsComponent implements OnInit{
  @Input() addresses: Array<AddressModel>;
  @Input() createResponsePage = false;
  @Input() isContainer =  false;

  destroy$ = new Subject<void>();
  showClear;
  isEnglishCountry;
  isEnglishCity;
  isEnglishPort;
  containerLoadType: ContainerLoadTypeResponseDataModel[] = [];
  countries;
  cities;
  ports;
  containerLoadTypeBulk; 
  containerLoadTypeContainer;
  portsType: PortTypeModel[];
  transPort: TransPortTypeResponseData[];
  customsGroup: FormGroup;
  editNumber = 500;
  language = 'fa';
  customs: Array<CustomsModel> = [];
  customsFirstAndLast: Array<CustomsModel> = [];
  finishForm = false;
  edit = false;
  viewTab = false;
  fieldsAddress = 0;
  submit = false;
  serviceTypeId = 2;
  address = false;
  expressStatus = false;
  createModelShowsCustoms: CustomsModel;
  private subscription: Subscription;

  constructor(
    private titleCasePipe: TitleCasePipe,
    private baseInfoService: BaseInfoService,
    private router: Router,
    private quotePersistService: QuotePersistService,
    private formBuilder: FormBuilder,
    public customsService: CustomsService,
    private portsService: PortsService,
  ) { }

  ngOnInit() {
    this.initialForm();
    this.portType();

  }
  initialForm() {
    this.customsGroup = this.formBuilder.group({
      countryId: ['', [Validators.required]],
      cityId: ['', [Validators.required]],
      portId: [],
      address: [false],
      primaryMainStreet: [null, []],
      secondaryMainStreet: [null, []],
      primaryAvenu: [null, []],
      secondaryAvenu: [null, []],
      alley: [null, []],
      plateNumber: [null, []],
      unitNumber: [null, []],
      portType: [null, []],
      transportType: [null, []],
      containerLoadTypeId: [null, []],
      origAndDestClearance: [],
      hasAddress: [false]
    });
  }
  portType() {
    this.baseInfoService.portType().subscribe((res: any) => {
      if (res) {
        this.portsType = res;
        if (this.customs?.length === 0) {
          this.fillPortType();
          if (this.createResponsePage) {
            this.patchDataResponse();
          }
        }
        if (this.expressStatus === true) {
          for (let i = 0; i < this.portsType.length; i++) {
            if (this.portsType[i].id === 3) {
              this.portsType.splice(2, 1)
            }
          }
          for (let i = 0; i < this.portsType.length; i++) {
            if (this.portsType[i].id === 4) {
              this.portsType.splice(2, 1)
            }
          }
          for (let i = 0; i < this.portsType.length; i++) {
            if (this.portsType[i].id === 5) {
              this.portsType.splice(2, 1)
            }
          }
          for (let i = 0; i < this.portsType.length; i++) {
            if (this.portsType[i].id === 6) {
              this.portsType.splice(2, 1)
            }
          }

        }
      }
    });
  }
  fillPortType() {
    this.customsGroup.get('portType').patchValue(this.portsType[0]?.id);
  }
  getTransport() {
    this.baseInfoService.getTransportType().subscribe(async (res) => {
      this.transPort = res;
    });
  }
  getDataSelectFields() {
    this.subscription = this.quotePersistService.getQuoteRequestFields().subscribe(res => {
      this.containerLoadType = res?.containerLoads;
      if(!(this.containerLoadType === undefined)){
        this.containerLoadTypeBulk = this.containerLoadType.filter(item => item?.isContainer !== "1");
        this.containerLoadTypeContainer = this.containerLoadType.filter(item => item?.isContainer !== "0");
      }
    }
    );
  }

  checkIsClearanceServiceType() {
    this.quotePersistService.getServiceTypeId().subscribe((value => {
      this.serviceTypeId = value;
      this.removeCustomsDependToServiceType();
    }));
  }
  removeCustomsDependToServiceType() {
    if (this.serviceTypeId === 1) {
      if (this.customs?.length > 1) {
        const numberDelete = this.customs.length - 1;
        this.customs.splice(1, numberDelete);
        this.customsService.sendCustoms(this.customs);
        this.customsGroup.reset();
        this.checkFinishForm();
      }
    }
  }
  getExpress() {
    const url = this.router.url;
    this.quotePersistService.getExpressStatus().subscribe(res => {
      this.expressStatus = url.includes('express');
    });
  }
  createResponseCustoms() {
    if (this.createResponsePage) {
      this.customsService.getFistAndLastCustoms().subscribe((customs => {
        if (customs) {
          this.customsFirstAndLast = customs;
        }
      }));
    }
  }
  patchDataResponse() {
    this.checkExpressReq();
    if (this.customsGroup.get('portType')?.value === 1) {
      this.customsGroup.get('countryId').patchValue(this.customsFirstAndLast[0]?.countryId);
      this.customsGroup.get('cityId').patchValue(this.customsFirstAndLast[0]?.cityId);
      this.customsGroup.get('portId').patchValue(this.customsFirstAndLast[0]?.portId);
      this.customsGroup.get('countryId').disable();
      this.customsGroup.get('cityId').disable();
      if (this.addresses[0]?.primaryMainStreet || this.addresses[0]?.secondaryMainStreet ||
        this.addresses[0]?.primaryAvenu || this.addresses[0]?.secondaryAvenu) {
        this.customsGroup.get('portId').enable();
        this.showClear = true;
      } else {
        this.customsGroup.get('portId').disable();
        this.showClear = false;

      }
    }
  }
  patchDestinationCustoms() {
    this.customsGroup.get('countryId').patchValue(this.customsFirstAndLast[this.customsFirstAndLast.length - 1]?.countryId);
    this.customsGroup.get('cityId').patchValue(this.customsFirstAndLast[this.customsFirstAndLast.length - 1]?.cityId);
    this.customsGroup.get('portId').patchValue(this.customsFirstAndLast[this.customsFirstAndLast.length - 1]?.portId);
    this.customsGroup.get('containerLoadTypeId').patchValue(this.customsFirstAndLast[this.customsFirstAndLast.length - 1]?.containerLoadTypeId?.id);
    this.customsGroup.get('transportType').patchValue(this.customsFirstAndLast[this.customsFirstAndLast.length - 1]?.transportType?.id);
    this.customsGroup.get('transportType').patchValue(this.addresses[this.customsFirstAndLast.length - 1]?.primaryMainStreet);

    this.customsGroup.get('countryId').disable();
    this.customsGroup.get('cityId').disable();
    if (this.addresses[1]?.primaryMainStreet || this.addresses[this.customsFirstAndLast.length - 1]?.secondaryMainStreet ||
      this.addresses[1]?.primaryAvenu || this.addresses[this.customsFirstAndLast.length - 1]?.secondaryAvenu) {
      this.customsGroup.get('portId').enable();
    } else {
      this.customsGroup.get('portId').disable();
    }
  }
  changePortType(event) {
    if (this.customsGroup.get('portType')?.value === 7 && this.createResponsePage) {
      this.patchDestinationCustoms();
    } else {
      this.customsGroup.enable();
      this.clearSearch('country')
    }

  }
  checkExpressReq() {
    if (this.customsFirstAndLast[1]?.containerLoadTypeId?.id === 11) {
      this.expressStatus = true;
    }
  }
  patchFormWithCache() {
    this.customs = [];
    if (!!localStorage.getItem('customs')) {
      this.customs = JSON.parse(localStorage.getItem('customs'));
    }
  }
  getTitle(port) {
    return port?.enTitle;
  }
  onSelectionCountry(event) {
    const isEnglishCountry: boolean = this.isEnglishText(event.data);
    this.isEnglishCountry = isEnglishCountry;
    const country = this.customsGroup.value.countryId;
    if (country.length >= 1) {
      return this.getCountry(this.titleCasePipe.transform(country));
    }
 
  }
  getCountry(country: string) {
    this.baseInfoService.getCountryList(country).subscribe((result) => {
      this.countries = result;
      if (this.countries === null || this.countries === undefined || this.countries.length === 0) {
        this.onBlur();
      }
    });
  }
  onBlur() {
    if (this.countries?.length === 0) {
      this.clearSearch('country');
    }
    else if (this.cities?.length === 0) {
      this.clearSearch('city');
    }
    else if (this.ports?.length === 0) {
      this.clearSearch('port');
    }
  }
  onSelectionCity(event) {
    const isEnglish: boolean = this.isEnglishText(event.data);
    this.isEnglishCity = isEnglish;
    const city = this.customsGroup.value.cityId;
    if (city.length >= 1) {
      return this.getCity(this.titleCasePipe.transform(city));
    }
  }
  getCity(destination) {
    const countryId = this.customsGroup.get('countryId').value.id;
    this.baseInfoService.getCityList(countryId, destination).subscribe((result) => {
      this.cities = result;
    });
  }
  onSelectionPort(event) {
    const isEnglish: boolean = this.isEnglishText(event.data);
    this.isEnglishPort = isEnglish;
    const portId = this.customsGroup.value.portId;
    if (portId.length >= 1) {
      return this.getPort(this.titleCasePipe.transform(portId));
    }
  }
  getTitlePort(port) {
    return port?.port_name;
  }
  getPort(dataTxt) {
    const countryCode = this.customsGroup.get('countryId').value.IsoCode;
    this.portsService.getMultiplePorts([1, 2, 3, 4], dataTxt, countryCode)
      .subscribe((result) => {
        this.ports = result;
      });
  }
  checkCheckBoxAddress(event) {
    this.address = event?.detail.checked === true;
    if (!this.address) {
      this.customsGroup.controls.primaryMainStreet.patchValue(null);
      this.customsGroup.controls.secondaryMainStreet.patchValue(null);
      this.customsGroup.controls.primaryAvenu.patchValue(null);
      this.customsGroup.controls.secondaryAvenu.patchValue(null);
      this.customsGroup.controls.alley.patchValue(null);
      this.customsGroup.controls.plateNumber.patchValue(null);
      this.customsGroup.controls.unitNumber.patchValue(null);
    }
  }
  clearSearch(name: string) {
    if (name === 'country') {
      this.customsGroup.patchValue({ countryId: null });
      this.countries = [];
      this.cityRemove();
      this.portRemove();
    }
    if (name === 'city') {
      this.cityRemove();
      this.portRemove();
    }
    if (name === 'port') {
      this.portRemove();
    }
  }
  cityRemove() {
    this.customsGroup.patchValue({ cityId: null });
    this.cities = [];
  }
  portRemove() {
    this.customsGroup.patchValue({ portId: null });
    this.ports = [];
  }
  addCustoms() {
    if (this.expressStatus && this.customs.length > 0) {
      this.customsGroup.get('transportType').patchValue(this.transPort[0]?.id);
      const containerLoadType = this.containerLoadType.find((p) => p.id === 11);
      this.customsGroup.get('containerLoadTypeId').patchValue(containerLoadType?.id);
    }
    this.addValidatorRequiredTransport();
    this.customsGroup.markAllAsTouched();
    this.submit = true;
    this.checkValidationQuoteRequestAddress();
    if (((this.customsGroup.valid) && ((this.address && this.fieldsAddress > 1) || (!this.address)))) {
      this.createModelPushShowsCustoms(this.customsGroup.value);
      this.customs.push(this.createModelShowsCustoms);
      if (this.customsGroup.controls.portType.value !== 7) {
        this.customsGroup.reset();
      }
      if (this.customsGroup.controls.portType.value === 7) {
        this.finishForm = true;
      }
      this.clearSearch('country');
      this.submit = false;
      this.customsGroup.enable();
      this.customsService.sendCustoms(this.customs);
    }
  }
  createModelPushShowsCustoms(customsForm) {
    const portType = this.portsType.find((p) => p.id === customsForm.portType);
    if (customsForm.portType !== 1) {
      const transportType = this.transPort.find((p) => p.id === customsForm.transportType);
      const containerLoadTypeId = this.containerLoadType.find((p) => p.id === customsForm.containerLoadTypeId);
      this.createModelShowsCustoms = {
        ...customsForm, portType, transportType, containerLoadTypeId,
        countryId: this.customsGroup.get('countryId')?.value,
        cityId: this.customsGroup.get('cityId')?.value,
        portId: this.customsGroup.get('portId')?.value,
      };
    }
    else {
      this.createModelShowsCustoms = {
        ...customsForm, portType,
        countryId: this.customsGroup.get('countryId')?.value,
        cityId: this.customsGroup.get('cityId')?.value,
        portId: this.customsGroup.get('portId')?.value,
      };
    }
    this.checkFinishForm();
  }
  deleteCustoms(event, index) {
    for (let i = 0; i < this.customs?.length; i++) {
      if (i === index) {
        this.customs.splice(i, 1);
      }
    }
    this.customsService.sendCustoms(this.customs);
  }
  editCustoms(event, index) {
    this.edit = true;
    this.editNumber = index;
    this.customsGroup.patchValue(this.customs[index]);
    this.customsGroup.controls.portType.patchValue(this.customs[index]?.portType?.id);
    if (this.customsGroup.controls.portType.value !== 1) {
      this.customsGroup.controls.transportType.patchValue(this.customs[index]?.transportType?.id);
      this.customsGroup.controls.containerLoadTypeId.patchValue(this.customs[index]?.containerLoadTypeId?.id);
    }
    if ((this.createResponsePage) && (this.customsGroup.get('portType').value === 1 || this.customsGroup.get('portType').value === 7)) {
      this.customsGroup.get('countryId').disable();
      this.customsGroup.get('cityId').disable();
      if (this.customsGroup.get('portType').value === 1) {
        if (this.addresses[0]?.primaryMainStreet || this.addresses[0]?.secondaryMainStreet ||
          this.addresses[0]?.primaryAvenu || this.addresses[0]?.secondaryAvenu) {
          this.customsGroup.get('portId').enable();
        } else {
          this.customsGroup.get('portId').disable();
        }
      } else if (this.customsGroup.get('portType').value === 7) {
        if (this.addresses[1]?.primaryMainStreet || this.addresses[1]?.secondaryMainStreet ||
          this.addresses[1]?.primaryAvenu || this.addresses[1]?.secondaryAvenu) {
          this.customsGroup.get('portId').enable();
        } else {
          this.customsGroup.get('portId').disable();
        }
      }
    }
    this.customsGroup.updateValueAndValidity();
    this.submit = false;
  }
  submitEditCustoms() {
    this.addValidatorRequiredTransport();
    this.customsGroup.markAllAsTouched();
    this.checkValidationQuoteRequestAddress();
    this.submit = true;
    if ((this.customsGroup.get('address').value && this.fieldsAddress > 2) || !this.customsGroup.get('address').value
      || this.createResponsePage) {
      if (this.customsGroup.valid) {
        this.createModelPushShowsCustoms(this.customsGroup.value);
        this.customs.splice(this.editNumber, 1, this.createModelShowsCustoms);
        this.customs.find((c) => {
          this.finishForm = c.portType?.id === 7;
        });
        this.getTitle(null);
        this.clearSearch('country');
        this.editNumber = 500;
        this.edit = false;
        this.customsGroup.reset();
        this.customsService.sendCustoms(this.customs);
      }
    }
  }
  addValidatorRequiredTransport() {
    const portTypeId = +this.customsGroup.get('portType').value;
    if (portTypeId !== 1) {
      this.customsGroup.get('transportType').addValidators(Validators.required);
      this.customsGroup.get('containerLoadTypeId').addValidators(Validators.required);
    } else if (portTypeId === 1) {
      this.customsGroup.controls.transportType.clearValidators();
      this.customsGroup.controls.containerLoadTypeId.clearValidators();
    }
    this.customsGroup.controls.transportType.updateValueAndValidity();
    this.customsGroup.controls.containerLoadTypeId.updateValueAndValidity();
  }
  checkValidationQuoteRequestAddress() {
    this.fieldsAddress = 0;
    if (this.customsGroup.get('primaryMainStreet').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
    if (this.customsGroup.get('secondaryMainStreet').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
    if (this.customsGroup.get('primaryAvenu').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
    if (this.customsGroup.get('secondaryAvenu').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
    if (this.customsGroup.get('alley').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
    if (this.customsGroup.get('plateNumber').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
    if (this.customsGroup.get('unitNumber').value) {
      this.fieldsAddress = (this.fieldsAddress + 1);
    }
  }
  checkHasAddressCreateResponse() {
    const endNumber = this?.customs?.length - 1;
    if (this.customs[0].primaryMainStreet || this.customs[0].secondaryMainStreet ||
      this.customs[0].primaryAvenu || this.customs[0].secondaryAvenu) {
      this.customs[0].hasAddress = true;
    }
    if (this.customs[endNumber].primaryMainStreet || this.customs[endNumber].secondaryMainStreet ||
      this.customs[endNumber].primaryAvenu || this.customs[endNumber].secondaryAvenu) {
      this.customs[endNumber].hasAddress = true;
    }
  }
  checkFinishForm() {
    if (this.customs?.length) {
      this.customs.find((p) => {
        this.finishForm = p?.portType?.id === 7;
      });
    }
  }
  isEnglishText(value: string): boolean {
    const englishRegex: RegExp = /^[a-zA-Z\s]+$/;
    return englishRegex.test(value);
  }
}